/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_FrameInputs */

const en_gc_editor_frame = /** @type {(inputs: Gc_Editor_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official GridCraft spreadsheet editor`)
};

const zh_gc_editor_frame = /** @type {(inputs: Gc_Editor_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`官方 GridCraft 电子表格编辑器`)
};

/**
* | output |
* | --- |
* | "Official GridCraft spreadsheet editor" |
*
* @param {Gc_Editor_FrameInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_frame = /** @type {((inputs?: Gc_Editor_FrameInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_FrameInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_frame(inputs)
	return zh_gc_editor_frame(inputs)
});
export { gc_editor_frame as "gc.editor.frame" }